<template>
  <VFold
    v-if="content"
    class="fold-wrapper"
    :title="title"
    :color="ColorType.gray"
    :defaultWeight="FoldTextWeight.regular"
    :font-color="FoldTextColor.disable"
    :size="14"
    :defaultState="true"
  >
    <div class="contents" ref="contents"></div>
  </VFold>
</template>

<script>
import VP from '../../atoms/VP'

import VFold, {
  ColorType,
  FoldTextColor,
  FoldTextWeight
} from '@/presentationals/v2/components/layouts/molecules/VFold'
import VBlock from '../../molecules/VBlock'

export default {
  name: 'PreOrderTerm',
  components: { VFold, VBlock, VP },
  props: {
    title: {
      type: String,
      required: true
    },
    content: {
      type: String,
      required: false
    }
  },
  updated() {
    this.$refs.contents.innerHTML += this.content
  },
  data() {
    return {
      ColorType,
      FoldTextColor,
      FoldTextWeight
    }
  }
}
</script>

<style lang="scss">
@import '~@/assets/scss/modules/colors';
.terms-wrap,
.terms-cont {
  font-size: 12px;
  border-collapse: collapse;

  table {
    border: 1px solid $light-gray-2;
    border-spacing: 0 0;
    border-collapse: collapse;

    th,
    td {
      border: 1px solid $light-gray-2;
      font-size: 11px !important;
      border-collapse: collapse;
    }

    strong {
      font-size: 11px !important;
    }
  }
}
</style>

<style lang="scss" scoped>
@import '~@/assets/scss/modules/colors';

.fold-wrapper {
  box-sizing: border-box;
  border-bottom: 1px solid $light-gray-5;
  padding-bottom: 14px !important;
  // padding-bottom: 11px !important;

  .contents {
    color: $gray-3;

    padding: 0 15px 12px 15px;
    margin-top: 10px;
    height: 80px !important;
    overflow: scroll;
  }
}
</style>
